import React, { PropsWithChildren } from "react";

interface Props {
  title?: string;
}

const FooterSection = ({ title, children }: PropsWithChildren<Props>) => {
  return (
    <div className="flex flex-1 flex-col gap-1.5">
      <h2 className="text-l border-grey-fog-1 border-b">{title}</h2>
      {children}
    </div>
  );
};

export default FooterSection;
